import { Injectable, Injector } from "@angular/core";
import { BfxBlotterOrdersActionSubject } from "app/bfx-blotter-orders/bfx-blotter-orders-action-subject.module";
import { BfxBlotterOrdersContextMenuService } from "app/bfx-blotter-orders/bfx-blotter-orders-contextmenu.service";
import { BfxExecutionMonitorMenuService } from "app/bfx-execution-monitor/services/bfx-execution-monitor-menu.service";
import { BfxOrderDetailsContextMenuState } from "app/bfx-order-details/model/BfxOrderDetailsContextMenuState";
import { OrderDataImpl } from "shared/cubiq-model-multi-asset";
import {
  ActiveUserProfilePromiseService,
  BfxBlotterOrdersContextMenuItem,
  BfxBlotterOrdersContextMenuPromiseService,
  ContextMenuServiceResponse,
  OrderDataPromiseLookupService,
  SystemConfigPromiseService,
  TraderGroupPromiseLookupService,
} from "shared/cubiq-services";

@Injectable()
export class BfxExecutionMonitorContextMenuService extends BfxBlotterOrdersContextMenuService {
  constructor(
    orderDataService: OrderDataPromiseLookupService,
    systemConfigService: SystemConfigPromiseService,
    traderGroupService: TraderGroupPromiseLookupService,
    activeUserService: ActiveUserProfilePromiseService,
    contextMenuService: BfxExecutionMonitorMenuService,
    actionSubject: BfxBlotterOrdersActionSubject,
  ) {
    super(
      orderDataService,
      systemConfigService,
      traderGroupService,
      activeUserService,
      contextMenuService,
      actionSubject,
    );
  }

  public getMenuItemsForOrder(
    order: OrderDataImpl,
  ): ContextMenuServiceResponse<OrderDataImpl, BfxBlotterOrdersContextMenuItem> {
    return this.contextMenuService.getMenuItemsForDataItem(order, this.menuState);
  }
}
